module.exports = __webpack_public_path__ + "static/media/CheckOut.6a8fc839.svg";